import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";

import { Factura } from "./factura";
import { ViajeCobranzaDto } from 'app/models/requireme';

const controller = rpcController("Cobranza2");

export const Cobranza2 = cacheResource({

    /**Obtiene las sugerencias de creación de un contrarecibo */
    ObtenerGuiasFacturar: async (filtro: models.FiltroGuiasContrarecibos): Promise<models.ContrareciboSugeridoModel[]> => await controller('ObtenerGuiasFacturar', {}, filtro),

    /**Obtiene los pquetes pp a crédito pendientes de facturar */
    ObtenerPaquetesPPFacturar: async (filtro: models.FiltroGuiasContrarecibos): Promise<models.ContrareciboSugeridoModel[]> => await controller('ObtenerPaquetesPPFacturar', {}, filtro),

    /**
     * Genera una factura y contrarecibo por cliente de cada una de las guias que el tiempo desde su creación (si fue pagada en origen) o desde su entrega (si fue FXC) sobrepasa
     * los días de crédito del cliente que le toca pagar esa factura, siempre y cuando esa factura haya sido pagada con crédito.
     */
    FacturarGuiasCredito: async (foliosGuias: string[]): Promise<string[]> => await controller('FacturarGuiasCredito', {}, foliosGuias),

    /**Obtiene todos los clientes pendientes de pagar sus facturas dada una sucursal de cobranza */
    ObtenerClientesPendientes: async (idSucursalCobranza: number): Promise<models.ClientePendienteDto[]> => await controller("ObtenerClientesPendientes", { idSucursalCobranza }),

    /**Crea un viaje de cobranza con todas las facturas pendientes de pago de los clientes especificados */
    CrearViajeCobranza: async (model: models.NuevoViajeCobranzaModel): Promise<number> => await controller('CrearViajeCobranza', {}, model),

    /**Consulta los viajes de cobranza */
    QueryViajes: async (filtro: models.FiltroViajeCobranza): Promise<ViajeCobranzaDto[]> => await controller("QueryViajes", {}, filtro),

    /**Obtiene un viaje de cobranza */
    GetViaje: async (idViaje: number): Promise<ViajeCobranzaDto> => await controller("GetViaje", { idViaje }),

    /**Obtiene cuanto dinero en credito debe un cliente */
    SaldoCliente: async (idCliente: number): Promise<number> => await controller('SaldoCliente', { idCliente }),

    /**Obtiene el reporte de viaje de cobranza */
    ImprimirViaje: async (idViajeCobranza: number): Promise<string> => await controller('ImprimirViaje', { idViajeCobranza }),

    TieneCliente: async (id: number): Promise<models.Usuario> => await controller('TieneCliente', { id }),
}, {}, {
        FacturarGuiasCredito: true,
        CrearViajeCobranza: true
    });



addOnInvalidateHandler(Factura, () => invalidateResource(Cobranza2));
addOnInvalidateHandler(Cobranza2, () => invalidateResource(Factura));


// WEBPACK FOOTER //
// ./app/resources/items/cobranza2.tsx